export class MoleculePanelOverviewHeaderMultiUnlockEmailActionComponent {
    public templateUrl = require('./multi-unlock-email-action.html?external');
}
